<div class="payment-container">
  <div  class="modal" tabindex="-1" role="dialog" id="modErrPay" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body"><span class="text-danger text-center font-weight-bold">{{errorMessage}}</span></div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
  @if (isPayment&&!isError) {
    <div>
      <div id="payment-page" class="payment-page">
        <h5>Details paiement</h5>
        <div class="mb-3">
          <label for="merchantName" class="form-label">{{orderDetails?.merchantName}}</label>
        </div>
        <div class="mb-3">
          <label for="amount" class="form-label ">Montant :<span class="fw-bold">{{orderDetails?.amount}} {{orderDetails?.currencyCode}}</span></label>
        </div>
        <div class="payment-header">
          <h3></h3>
          <p>Veuillez choisir votre moyen de paiement</p>
        </div>
        <div class="row justify-content-center gap-method">
          <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2 ml-3 p-2" style="width: auto;" data-method="card" (click)="onSelectPaymentMethod('card')">
            <img class="img-fluid" src="images/visamaster.png" alt="carte" width="50">
            <p class="mt-2 mb-0 text-center">Carte</p>
          </div>
          <div class="col-3 ml-2 payment-method border rounded d-flex flex-column justify-content-center mb-2" style="width: 135px;" data-method="omsn" (click)="onSelectPaymentMethod('omsn')">
            <img class="mt-4 img-fluid justify-content-center" src="images/omsn.webp" alt="orange money" width="50">
            <p class="mt-1 ml-3">Orange money</p>
          </div>
          <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2" data-method="wvsn" style="width: auto;" (click)="onSelectPaymentMethod('wvsn')">
            <img class="mt-4 img-fluid justify-content-center" src="images/wave-logo.webp" alt="wave" width="50">
            <p class="mt-1  ml-3">Wave</p>
          </div>
        </div>
        <form  [formGroup]="formPay" >
          <div class="row justify-content-center">
            <div class=" form form-group col-sm-5  mb-2">
              @if (isWallet) {
                <input type="tel" placeholder="Numero t&#233;l&#233;phone" class="form-control" formControlName="phone">
              }
            </div>
          </div>
        </form>
        @if (isValid()) {
          <div class="d-grid gap-2 col-6 mx-auto">
            <button class="btn btn-primary" (click)="processPayment()">Valider</button>
          </div>
        }
      </div>
    </div>
  }
  @if (!isPayment&&!isError) {
    <div  class="row justify-content-center">
      <div class="d-flex justify-content-center" style="width: 300;">Scannez et payez </div>
      <div class="d-flex justify-content-center">
        <div class="d-block">
          <img class="img-fluid" src="images/omsn.webp" alt="orange money" width="120" height="50">
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <qrcode [qrdata]="qrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
      </div>
    </div>
  }

</div>


